import React from 'react';
import RagKGApp from '../libs/RagKGApp';

const KnowledgeRetrieval: React.FC = () => {
  return (
    <div style={{ width: '100%', height: '98%' }}>
      <RagKGApp hashPath="retrieval" />
    </div>
  );
};

export default KnowledgeRetrieval;

